import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { isHomeOn } from '~/permissions/hasHome';

export function useHasHome() {
  // Read directly: Home exists when `newhome-ekp` is on, with no Pilot wait.
  const home = useFlag(FlagType.Home);
  const adminDate = useFlag(FlagType.HomeAdminSettings);
  return isHomeOn(home, adminDate);
}
